export const PULLING_PARENT_EVENTS = {
  VIEW_CREATE_TEEN_ERROR: 'view_create_teen_error',
  SELECT_CREATE_TEEN_ERROR_RETRY: 'select_create_teen_error_retry',
  SELECT_CREATE_TEEN_ERROR_CS: 'select_create_teen_error_cs',
} as const;
